import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { promotionsRoute } from '.'

const PromoTermsAndConditions = lazyRouteComponent(
  () => import('../../pages/promotions/promo-terms-and-conditions'),
)

export const promoTermsRoute = createRoute({
  getParentRoute: () => promotionsRoute,
  path: '$promoId',
  component: PromoTermsAndConditions,
})
